import React from 'react';
import { useTranslation } from 'react-i18next';

const Th = ({ children, align = 'left' }) => (
    <th style={{
        padding: '10px 14px', fontSize: 11, fontWeight: 700,
        color: '#9ca3af', textTransform: 'uppercase',
        letterSpacing: '0.4px', textAlign: align,
        backgroundColor: '#f9fafb',
        borderBottom: '1px solid #f3f4f6',
        whiteSpace: 'nowrap',
    }}>
        {children}
    </th>
);

const Cell = ({ children, align = 'left', muted, bold }) => (
    <td style={{
        padding: '10px 14px', fontSize: 13,
        color: muted ? '#9ca3af' : '#374151',
        fontWeight: bold ? 700 : muted ? 400 : 500,
        textAlign: align,
        borderBottom: '1px solid #f3f4f6',
        whiteSpace: 'nowrap',
    }}>
        {children ?? '—'}
    </td>
);

const fmt = (n) => (n != null ? Number(n).toLocaleString() : '—');
const fmtWt = (n) => (n != null ? `${parseFloat(n).toFixed(2)} T` : '—');

const ROW_ACCENT = ['#0891b2', '#059669', '#7c3aed', '#d97706', '#3b82f6', '#f43f5e'];

const ChallanCustomersTable = ({ items = [], loading }) => {
    const { t } = useTranslation();
    return (
        <div style={cardStyle}>
            <div style={{ padding: '14px 18px', borderBottom: '1px solid #f3f4f6', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                <div>
                    <div style={{ fontSize: 15, fontWeight: 700, color: '#111827' }}>{t('challanAnalytics.tables.customerBreakdown')}</div>
                    <div style={{ fontSize: 12, color: '#9ca3af', marginTop: 2 }}>{t('challanAnalytics.subtitles.perCustomer')}</div>
                </div>
                {items.length > 0 && (
                    <span style={{ fontSize: 11, fontWeight: 700, color: '#059669', backgroundColor: '#ecfdf5', borderRadius: 20, padding: '3px 10px' }}>
                        {items.length} {t('challanAnalytics.labels.customersCountSuffix')}
                    </span>
                )}
            </div>

            {loading && <EmptyState message={t('challanAnalytics.emptyStates.loadingCustomers')} />}
            {!loading && !items.length && <EmptyState message={t('challanAnalytics.emptyStates.noCustomerData')} />}

            {!loading && items.length > 0 && (
                <div style={{ overflowX: 'auto' }}>
                    <table style={{ width: '100%', borderCollapse: 'collapse', minWidth: 700 }}>
                        <thead>
                            <tr>
                                <Th>#</Th>
                                <Th>{t('common.analyticsColumns.customer')}</Th>
                                <Th align="right">{t('common.analyticsColumns.challans')}</Th>
                                <Th align="right">{t('common.analyticsColumns.weight')}</Th>
                            </tr>
                        </thead>
                        <tbody>
                            {items.map((row, i) => {
                                const accent = ROW_ACCENT[i % ROW_ACCENT.length];
                                return (
                                    <tr
                                        key={row.customer_id ?? row.id ?? i}
                                        style={{ backgroundColor: i % 2 === 0 ? '#ffffff' : '#fafafa' }}
                                        onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = '#f0fdf4')}
                                        onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = i % 2 === 0 ? '#ffffff' : '#fafafa')}
                                    >
                                        <Cell muted>{i + 1}</Cell>
                                        <Cell>
                                            <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                                                <div style={{
                                                    width: 28, height: 28, borderRadius: 8, flexShrink: 0,
                                                    backgroundColor: `${accent}18`,
                                                    display: 'flex', alignItems: 'center', justifyContent: 'center',
                                                    fontSize: 11, fontWeight: 800, color: accent,
                                                }}>
                                                    {(row.customer_name ?? row.name ?? '?').charAt(0).toUpperCase()}
                                                </div>
                                                <div>
                                                    <div style={{ fontWeight: 700, color: '#111827', fontSize: 13 }}>
                                                        {row.customer_name ?? row.name ?? '—'}
                                                    </div>
                                                    {row.tally_name && (
                                                        <div style={{ fontSize: 11, color: '#9ca3af' }}>{row.tally_name}</div>
                                                    )}
                                                </div>
                                            </div>
                                        </Cell>
                                        <Cell align="right" bold>
                                            {fmt(row.challan_count ?? row.total_challans ?? row.count)}
                                        </Cell>
                                        <Cell align="right">
                                            {fmtWt(row.total_weight_tons ?? row.weight_tons)}
                                        </Cell>
                                    </tr>
                                );
                            })}
                        </tbody>
                    </table>
                </div>
            )}
        </div>
    );
};

const EmptyState = ({ message }) => (
    <div style={{ padding: 40, textAlign: 'center', color: '#9ca3af', fontSize: 13 }}>{message}</div>
);

const cardStyle = {
    backgroundColor: '#fff', borderRadius: 16,
    border: '1px solid #f3f4f6',
    boxShadow: '0 1px 4px rgba(0,0,0,0.06)',
    overflow: 'hidden',
};

export default ChallanCustomersTable;
